// Page contact
function Contact() {
    return (
        <section className="max-w-3xl mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10">Contact</h1>
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-8">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm text-gray-400 mb-2">Name</label>
                        <input type="text" placeholder="Your name" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none" />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-400 mb-2">Email</label>
                        <input type="email" placeholder="your@email.com" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none" />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-400 mb-2">Message</label>
                        <textarea rows="5" placeholder="Your message..." className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none resize-none"></textarea>
                    </div>
                    <button className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold">Send Message</button>
                </div>
            </div>
            <div className="mt-10 text-gray-400">
                <p>Email: guillaume@example.com</p>
                <p className="mt-2">GitHub: github.com/MetanaWatcher</p>
            </div>
        </section>
    );
}

export default Contact;